import React, { type ReactNode } from 'react';
import styled from 'styled-components';

import { uriSchemes } from '#@/shared/constants';
import { mixins } from '#@/shared/utils/styles';

const ExternalLinkStyled = styled.a`
  ${mixins.link()}
`;

type Type = 'phone' | 'email';

export interface ExternalLinkProps {
  to: string;
  type?: Type;
  className?: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  children?: ReactNode;
}

export const prependProtocol = (url: string, type: Type | undefined) => {
  if (uriSchemes.some((scheme) => url.startsWith(scheme))) {
    return url;
  }

  if (type === 'phone') {
    return `tel:${url}`;
  }

  if (type === 'email') {
    return `mailto:${url}`;
  }

  return `http://${url}`;
};

const ExternalLink = React.forwardRef<HTMLAnchorElement, ExternalLinkProps>(
  ({ to, type, className, children, ...props }, ref) => (
    <ExternalLinkStyled
      className={className}
      href={prependProtocol(to, type)}
      target="_blank"
      rel="noopener noreferrer"
      ref={ref}
      type={type}
      {...props}
    >
      {children}
    </ExternalLinkStyled>
  ),
);

ExternalLink.displayName = 'ExternalLink';

export default ExternalLink;
